// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partner-orders-table-section {
  width: 100%;
  max-width: 100%;
}

.partner-orders-table-section .table-header-item {
  gap: 0.75rem;
}

.partner-orders-table-section .partner-orders-search {
  width: 100%;
  max-width: 350px;
}

.partner-orders-table-scroll {
  display: block;
  width: 100%;
  max-width: 100%;
  max-height: min(41em, 70vh);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  background-color: #fff;
}

.partner-orders-table {
  width: max-content;
  min-width: 100%;
  margin-bottom: 0;
  table-layout: auto;
}

.partner-orders-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  white-space: nowrap;
}

.partner-orders-table tbody th {
  padding: 0.5rem 0.75rem !important;
  vertical-align: middle;
}

.partner-orders-table tbody th.ps-5 {
  padding-left: 1.5rem !important;
}

.partner-orders-table tbody th:nth-child(2) {
  min-width: 11rem;
  white-space: normal;
  word-break: break-word;
}

.partner-orders-table tbody th:nth-child(3),
.partner-orders-table tbody th:nth-child(4) {
  min-width: 9.5rem;
  white-space: nowrap;
}

.partner-orders-table tbody th:nth-child(8) {
  min-width: 10rem;
}

.partner-orders-date-picker .dropdown-menu {
  z-index: 1050;
}

.partner-orders-status-badge {
  color: inherit;
  font-weight: 600;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
  padding: 6px 10px;
  min-width: 5em;
  width: fit-content;
  white-space: nowrap;
}

.partner-orders-status-pipeline {
  display: block;
  font-size: 12px;
  margin-top: 4px;
  white-space: normal;
}

.partner-orders-empty-row td {
  text-align: center;
  padding: 1.5rem;
}

.partner-orders-pagination {
  clear: both;
  position: relative;
  z-index: 1;
  margin-top: 1.25rem;
}

.partner-orders-pagination > div {
  margin-top: 0 !important;
}

@media (max-width: 991px) {
  .partner-orders-table-section .table-header-item {
    flex-direction: column;
    align-items: stretch !important;
  }

  .partner-orders-table-section .partner-orders-search {
    max-width: 100%;
  }

  .partner-orders-table-section .partner-orders-date-picker {
    width: 100%;
  }

  .partner-orders-table-section .partner-orders-date-picker > .dropdown {
    flex-wrap: wrap;
    width: 100%;
  }

  .partner-orders-table-section .order-date {
    justify-content: flex-start;
    padding-right: 0;
  }

  .partner-orders-table-scroll {
    max-height: min(36em, 60vh);
  }
}

@media (max-width: 767px) {
  .partner-orders-table-scroll {
    max-height: min(32em, 55vh);
  }

  .partner-orders-date-picker .dropdown-menu {
    left: 0 !important;
    right: auto;
    max-width: calc(100vw - 2rem);
    overflow-x: auto;
  }

  .partner-orders-table tbody th.ps-5 {
    padding-left: 0.75rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/tables/PartnerOrdersTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,iCAAiC;EACjC,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,sBAAsB;IACtB,+BAA+B;EACjC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;EAClC;AACF","sourcesContent":[".partner-orders-table-section {\n  width: 100%;\n  max-width: 100%;\n}\n\n.partner-orders-table-section .table-header-item {\n  gap: 0.75rem;\n}\n\n.partner-orders-table-section .partner-orders-search {\n  width: 100%;\n  max-width: 350px;\n}\n\n.partner-orders-table-scroll {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  max-height: min(41em, 70vh);\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  border: 1px solid #e9ecef;\n  border-radius: 0.375rem;\n  background-color: #fff;\n}\n\n.partner-orders-table {\n  width: max-content;\n  min-width: 100%;\n  margin-bottom: 0;\n  table-layout: auto;\n}\n\n.partner-orders-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  white-space: nowrap;\n}\n\n.partner-orders-table tbody th {\n  padding: 0.5rem 0.75rem !important;\n  vertical-align: middle;\n}\n\n.partner-orders-table tbody th.ps-5 {\n  padding-left: 1.5rem !important;\n}\n\n.partner-orders-table tbody th:nth-child(2) {\n  min-width: 11rem;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.partner-orders-table tbody th:nth-child(3),\n.partner-orders-table tbody th:nth-child(4) {\n  min-width: 9.5rem;\n  white-space: nowrap;\n}\n\n.partner-orders-table tbody th:nth-child(8) {\n  min-width: 10rem;\n}\n\n.partner-orders-date-picker .dropdown-menu {\n  z-index: 1050;\n}\n\n.partner-orders-status-badge {\n  color: inherit;\n  font-weight: 600;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 25px;\n  padding: 6px 10px;\n  min-width: 5em;\n  width: fit-content;\n  white-space: nowrap;\n}\n\n.partner-orders-status-pipeline {\n  display: block;\n  font-size: 12px;\n  margin-top: 4px;\n  white-space: normal;\n}\n\n.partner-orders-empty-row td {\n  text-align: center;\n  padding: 1.5rem;\n}\n\n.partner-orders-pagination {\n  clear: both;\n  position: relative;\n  z-index: 1;\n  margin-top: 1.25rem;\n}\n\n.partner-orders-pagination > div {\n  margin-top: 0 !important;\n}\n\n@media (max-width: 991px) {\n  .partner-orders-table-section .table-header-item {\n    flex-direction: column;\n    align-items: stretch !important;\n  }\n\n  .partner-orders-table-section .partner-orders-search {\n    max-width: 100%;\n  }\n\n  .partner-orders-table-section .partner-orders-date-picker {\n    width: 100%;\n  }\n\n  .partner-orders-table-section .partner-orders-date-picker > .dropdown {\n    flex-wrap: wrap;\n    width: 100%;\n  }\n\n  .partner-orders-table-section .order-date {\n    justify-content: flex-start;\n    padding-right: 0;\n  }\n\n  .partner-orders-table-scroll {\n    max-height: min(36em, 60vh);\n  }\n}\n\n@media (max-width: 767px) {\n  .partner-orders-table-scroll {\n    max-height: min(32em, 55vh);\n  }\n\n  .partner-orders-date-picker .dropdown-menu {\n    left: 0 !important;\n    right: auto;\n    max-width: calc(100vw - 2rem);\n    overflow-x: auto;\n  }\n\n  .partner-orders-table tbody th.ps-5 {\n    padding-left: 0.75rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
